<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page13"></a><i>The naked gospel [is] discovering what was the gospel<br/>which our Lord and his apostles preached; what additions<br/>and alterations latter ages have made in it;<br/>what advantages and damages have thereupon ensued.</i></p>
<p class="center">Arthur Bury, 1691</p>
<div class="image" id="image1">
<p class="center"><img alt="image 1" src="images/01.jpg"/></p>
</div>
<p class="center">Arthur Bury’s book titled <i>The Naked Gospel</i><br/>was burned by the church of his day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008excerpt.vue?92a94a5e